import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectRights = (store: StoreSchema) => store.newApplicationState.newApplication.rights